import React from 'react';

interface HowItWorksStepCardProps {
  stepNumber: string;
  title: string;
  description: string;
  tile: React.ReactNode;
}

/**
 * Step Card Component for How it works section
 * Uses flex-col with consistent tile anchoring
 */
const HowItWorksStepCard = ({
  stepNumber,
  title,
  description,
  tile,
}: HowItWorksStepCardProps) => (
  <div className="border border-neutral-200 bg-white rounded-xl p-6 flex flex-col h-full">
    {/* Header block: number + title + description */}
    <div>
      <div className="text-xs text-neutral-400 font-body mb-2">
        {stepNumber}
      </div>
      <h3 className="font-display text-xl text-neutral-900 mb-2">
        {title}
      </h3>
      <p className="text-sm font-body text-neutral-500 leading-relaxed">
        {description}
      </p>
    </div>
    {/* Tile container: fills remaining space, centers tile vertically */}
    <div className="mt-4 flex-1 flex items-start min-h-[220px]">
      <div className="w-full">
        {tile}
      </div>
    </div>
  </div>
);

export default HowItWorksStepCard;
